/**************************************************
 * Nombre:       Tarjeta_Tour
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Rating, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {FiberManualRecord} from '@mui/icons-material'
import {useNavigate} from "react-router-dom";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import tmp_tours from '../../Recursos/tmp_tours.png'


const Tarjeta_Tour = ({item}) => {
    const navigate = useNavigate()

    return (
        <Grid
            onClick={() => navigate('/Detalle/' + item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                cursor: 'pointer',
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Rating size={'medium'} value={5}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{
                justifyContent: 'flex-start',
                mt: 2,
                borderRadius: 3,
                "&:hover": {
                    boxShadow: 8
                }
            }}>
                <img src={item.img ? item.img : tmp_tours} width={'100%'} height={'auto'} style={{borderRadius: 12}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2, px: 1}}>
                <Typography sx={{color: theme.palette.primary.main, fontSize: 20, fontWeight: 800, lineHeight: 1.2}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {item.espeficiaciones.map((it, index) => {
                        return (
                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                <Typography sx={{fontSize: 14, lineHeight: 1.1}}>
                                    <span><FiberManualRecord
                                        sx={{
                                            fill: theme.palette.primary.main,
                                            width: 14,
                                            height: 14,
                                            pr: 0.5,
                                            mt: 0.1,
                                            mb: -0.1
                                        }}/>

                                    </span>
                                    <span style={{fontWeight: 600, paddingRight: 4}}>{it.nombre}:</span>
                                    {it.descripcion}

                                </Typography>
                            </Grid>
                        )
                    })}

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 1, px: 1}}>
                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                        <Typography
                            sx={{color: theme.palette.primary.main, fontSize: 14, fontWeight: 400}}>Precio</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -0.5}}>
                        <Typography
                            sx={{fontSize: 20, fontWeight: 800}}>{`${formatoMoneda(item.valor)}COP`}</Typography>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Tour

const items = [1, 2, 3]